import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { EntityTypesActions } from './entity-types.actions';
import { EMPTY, map, of, switchMap } from 'rxjs';
import { EntityTypeService } from '../../services/entity-type.service';
import { EntityType } from '../../models/entity-type.model';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectEntityTypesState } from './entity-types.selectors';

@Injectable()
export class EntityTypesEffects {
  constructor(private actions$: Actions, private store: Store, private entityTypeService: EntityTypeService) {}

  typesRequired$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityTypesActions.entity_types_required),
        concatLatestFrom(() => this.store.select(selectEntityTypesState)),
        switchMap(([_, currentState]) => {
          if (currentState.loaded || currentState.loading) {
            return EMPTY;
          }
          return of(EntityTypesActions.get_entity_types_start());
        })
      ),
    { dispatch: true }
  );

  loadingStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityTypesActions.get_entity_types_start),
        switchMap(() => {
          return this.entityTypeService.getEntityTypes().pipe(
            map(entityTypes => {
              const asMap: Record<string, EntityType> = {};
              entityTypes.forEach(t => (asMap[t.Key] = t));
              return EntityTypesActions.get_entity_types_success({ types: asMap });
            }),
            catchError(e => {
              console.info(e);
              return of(EntityTypesActions.get_entity_types_success({ types: { Aa: null } }));
            })
          );
        })
      ),
    { dispatch: true }
  );
}
